// @ts-nocheck
/**
 * @param axis
 */
export default function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
//# sourceMappingURL=getAltAxis.js.map